/** @format */

import History from "../../../assets/images/Activity History (1).svg";
import Transactions from "../../molecules/transactions";
import {
  Container,
  TransactionContainer,
  Empty,
  ImageContainer,
  CardHeading,
  CardContainer,
} from "./styles";

interface WithdrawTabProp {
  isTransactionActive: boolean;
  isConfirmed: boolean;
  setisConfirmed: any;
  balance: any;
  transactions: any;
}

const TransactionsTab = ({
  isTransactionActive,
  setisConfirmed,
  isConfirmed,
  balance,
  transactions,
}: WithdrawTabProp) => {
  return (
    <Container hidden={!isTransactionActive}>
      <div hidden={!isTransactionActive} className="md:ml-[8em]">
        <TransactionContainer>
          {transactions.length === 0 ? (
            <Empty>
              <ImageContainer>
                <img src={History} alt="shopping" />
              </ImageContainer>
              <p>No transactions Yet</p>
            </Empty>
          ) : (
            <>
              <CardHeading>Transactions</CardHeading>
              <CardContainer className="active">
                <Transactions transactions={transactions} setisConfirmed={setisConfirmed} isConfirmed={isConfirmed} />
              </CardContainer>
            </>
          )}
        </TransactionContainer>
      </div>
    </Container>
  );
};

export default TransactionsTab;
